import { css, styled } from '@zeiss/beyond-online-react';

interface SearchAndRedirectUrlContainerProps {
  children: React.ReactNode;
  redirectUrl?: string;
}

const Container = styled.div<{ $hasRedirectUrl: boolean }>`
  ${({ $hasRedirectUrl }) =>
    $hasRedirectUrl &&
    css`
      display: flex;
      flex-direction: column;
      gap: var(--spacing-s);
    `}
`;

export const SearchAndRedirectUrlContainer = ({
  children,
  redirectUrl,
}: SearchAndRedirectUrlContainerProps) => (
  <Container $hasRedirectUrl={!!redirectUrl}>{children}</Container>
);
